export const CONTENT_MODE_AI_SUGGESTIONS = "ai_suggestions" as const;
export const CONTENT_MODE_PLACEHOLDER_ONLY = "placeholder_only" as const;

export const FLOW_TYPE_MANUAL = "manual" as const;
export const FLOW_TYPE_FROM_TEMPLATE = "from_template" as const;

export type ContentMode =
  | typeof CONTENT_MODE_AI_SUGGESTIONS
  | typeof CONTENT_MODE_PLACEHOLDER_ONLY;

export type FlowType = typeof FLOW_TYPE_MANUAL | typeof FLOW_TYPE_FROM_TEMPLATE;
